import { render, staticRenderFns } from "./LinkFail.vue?vue&type=template&id=32a3a59f&scoped=true"
import script from "./LinkFail.vue?vue&type=script&lang=js"
export * from "./LinkFail.vue?vue&type=script&lang=js"
import style0 from "./LinkFail.vue?vue&type=style&index=0&id=32a3a59f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a3a59f",
  null
  
)

export default component.exports